import { createSlice } from '@reduxjs/toolkit';

export const toastSlice = createSlice({
    name: 'toast',
    initialState: {
        toasts: [], // { id, message, type, retryAction }
    },
    reducers: {
        addToast: (state, action) => {
            const newToast = {
                id: Date.now() + Math.random(), // Ensure uniqueness
                type: 'error',
                autoDismiss: true,
                ...action.payload,
            };
            state.toasts.push(newToast);
        },
        removeToast: (state, action) => {
            state.toasts = state.toasts.filter(t => t.id !== action.payload);
        },
        clearAllToasts: (state) => {
            state.toasts = [];
        },
    },
});

export const {
    addToast,
    removeToast,
    clearAllToasts,
} = toastSlice.actions;

export const selectToasts = state => state.toast.toasts;

export default toastSlice.reducer;
